import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imdb.png")